dmx.Attribute('animate-outview', 'mounted', function (node, attr) {
  node.outview = {
    effect: attr.value,
    delay: attr.modifiers.delay,
    duration: attr.modifiers.duration,
    ratio: (parseInt(attr.argument, 10) || 100) / 100,
  };
});